import { RouteAccessResult, validateRouteAccessType } from "./router.types";
import { PAGE_URLS } from "utils/constants";

export const validateRouteAccess: validateRouteAccessType = ({
  userData,
  route,
  customFallback,
}): RouteAccessResult => {
  try {
    // Evaluate the route's access rule
    const result = route.access.evaluate(userData, customFallback);

    if (!result.allowed) {
      // If access is denied, return the fallback information
      return {
        isAllowed: false,
        fallbackUrl: result.fallback?.url || PAGE_URLS.HOME,
        redirectingMessage: result.fallback?.message,
      };
    }

    // Access is allowed
    return { isAllowed: true };
  } catch (error) {
    // If there is an error, return the fallback information
    return {
      isAllowed: false,
      fallbackUrl: PAGE_URLS.HOME,
      redirectingMessage: "Error evaluating route access",
    };
  }
};
